<template>
	<div v-if="inEditMode">
		<closing-days-form
			:period="period"
			:translations="translations"
			:check-overlap="checkOverlap"
			@save="save" @cancel="cancel"
		></closing-days-form>
	</div>
	<div v-else class="columns" :class="{'is-loading': loader.loading}">
		<div class="column">
			<div class="has-text-weight-bold">
				{{ closedFromUntilInfo }}
			</div>
			<div v-if="period.block_card_creation_from">
				{{ cardsShipmentInfo }}
			</div>
		</div>
		<div class="column is-narrow" v-if="buttonsAreVisible && !loader.loading">
			<button @click="edit" class="button">{{ translations['buttons']['edit'] }}</button>
			<button @click="confirmDelete" class="button is-danger">{{ translations['buttons']['remove'] }}</button>
		</div>
		<simple-modal
			:display="showConfirmDeleteDialog"
			:title="translations['confirm_delete']['title']"
			@close="showConfirmDeleteDialog = false"
			class="has-text-centered"
			ref="dm"
		>
			<div class="has-text-centered">
				<button class="button is-danger is-marged-top" @click="destroy">
					{{ translations['confirm_delete']['confirm'] }}
				</button>
				<button class="button is-marged-top" @click="showConfirmDeleteDialog = false">
					{{ translations['buttons']['cancel'] }}
				</button>
			</div>
		</simple-modal>
	</div>
</template>

<script>
import ClosingDaysForm from "./closing-days-form";
import SimpleModal from "../modals/simple-modal";

export default {
	name: "closing-days-period",
	components: {
		SimpleModal,
		ClosingDaysForm
	},
	props: [ 'itemUrl', 'value', 'company', 'translations', 'checkOverlap' ],
	emits: [ 'input', 'deleted' ],
	data()
	{
		return {
			inEditMode: false,
			loader: {
				loading: false,
			},
			period: this.value,
			showConfirmDeleteDialog: false
		}
	},
	computed: {
		buttonsAreVisible()
		{
			return this.period.id > 0;
		},
		closedFromUntilInfo()
		{
			return this.translations['closed_from_until_info']
				.replace('{from}', moment(this.period.closed_from).format('D/M/YYYY'))
				.replace('{until}', moment(this.period.closed_until).format('D/M/YYYY'));
		},
		cardsShipmentInfo()
		{
			return this.translations['cards_shipment_info']
				.replace('{date}', moment(this.period.block_card_creation_from).format('D/M/YYYY'));
		}
	},
	methods: {
		edit()
		{
			this.inEditMode = true;
		},
		cancel()
		{
			this.inEditMode = false;
		},
		save()
		{
			this.inEditMode = false;
			(new ApiMonizze(new LoaderState(this.loader)))
				.postDataFromApi(
					this.itemUrl,
					this.period,
					(savedPeriod) => {
						this.period = savedPeriod;
						this.$emit('input', savedPeriod)
					}
				);
		},
		confirmDelete()
		{
			this.showConfirmDeleteDialog = true;
		},
		destroy()
		{
			this.showConfirmDeleteDialog = false;
			(new ApiMonizze(new LoaderState(this.loader)))
				.deleteDataFromApi(
					this.itemUrl,
					() => this.$emit('deleted', this.period.id)
				);
		}
	}
}
</script>
